import React, { ReactNode, useCallback, useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { ContentWrapper } from '../../../../common/content-wrapper';
import { useStyles } from './next-step.styles';
import { BackButton } from '../../../../common/back-button-new';
import { Page } from '../../page/page';

export const NextStep = (): JSX.Element => {
  const classes = useStyles();
  const intl = useIntl();
  const items: { item: string, itemExtra?: string, list?: string[] }[] = useMemo(() => {
    return [
      { item: 'next.list-1', itemExtra: 'next.list-1.phone' },
      { item: 'next.list-2' },
      { item: 'next.list-3', list: ['next.sublist-1', 'next.sublist-2', 'next.sublist-3', 'next.sublist-4'] },
      { item: 'next.list-4' },
    ];
  }, []);
  const getText = useCallback((id: string) => {
    return intl.formatMessage(
      { id },
      { sup: (chunks: ReactNode) => <sup>{chunks}</sup>, noBreak: <>&nbsp;</> },
    );
  }, []);

  return (
    <Page title={intl.formatMessage({ id: 'next.title' })}>
      <ContentWrapper>
        <div className={classes.root}>
          <BackButton />
          <h1 className={classes.title}>{intl.formatMessage({ id: 'next.title' })}{getText('next.title.icon')}</h1>
          <p className={classes.text}>{getText('next.text-1')}</p>
          <h2 className={classes.subtitle}>{getText('next.text-2')}</h2>
          <ol className={classes.list}>
            {items.map(({ item, itemExtra, list }, index) => (
              <li key={item} className={classes.listItem}>
                <span className={classes.icon}>{index + 1}</span>
                {getText(item)}
                {itemExtra && <a href="tel:88006007997" className={classes.link}><FormattedMessage id={itemExtra} /></a>}
                {list && (
                  <ul className={classes.sublist}>
                    {list.map((listItem) => <li key={listItem}>{getText(listItem)}</li>)}
                  </ul>
                )}
              </li>
            ))}
          </ol>
          <p className={classes.text}>{getText('next.text-3')}</p>
        </div>
      </ContentWrapper>
    </Page>
  );
};
